/** Nome acessível padrão do campo de busca (o Figma não desenha rótulo nem placeholder). */
export const SEARCH_MENU_SEARCH_LABEL = "Buscar";
